// ¿Se ofrece este producto hoy? Para las promos del día: el producto trae
// `available_days` (0 = domingo … 6 = sábado, como Date#getDay) y vacío o
// ausente significa todos los días.
//
// Se decide con la hora local del aparato y no con la del servidor, que vive
// en UTC: a las 18:00 en CDMX el servidor ya está en el día siguiente. Así
// también funciona igual contra la nube que contra la caja central sin red.
export const disponibleHoy = (producto, ahora = new Date()) => {
  const dias = producto?.available_days;
  if (!Array.isArray(dias) || dias.length === 0) return true;
  return dias.includes(ahora.getDay());
};
